/** @format */

import { sendQuery } from './functions';

export const loadUserQuery = async () => {
  const userData = await sendQuery(
    `query {
      user{
        id,
        files
        firstNameFa,
        lastNameFa,
        isActive,
        merchantType
        comNameFa
        commissionBack
        trusted
        permissionForApi
        hasBranch
        terminals{
          id
          farsiName
        }
        authentications{
          details
          type {
            id
          }
        }
        accounts{
          id
          title
          status{
            id
            title
          }
        }
        status{
          id
          title
        }      
      }
    }`,
  );

  return userData;
};

export const getUsersQuery = async (currentPage = 1, rowsPerPage = 10) => {
  const users = await sendQuery(
    `query {
      users(filterUsersInput: {page: ${currentPage}, limit: ${rowsPerPage}}) {
        data {
          id
          firstNameFa
          lastNameFa
          mobile
          emailAddress
          createdAt
          merchantType
          settleable
          terminals{
            id
          }
          status{
            id
            title
          }
          wallets{
            id
          }
          files
        }
        totalPages
        currentPage
        hasMorePages
        perPage
        from
        to
        lastPage
      }
    }`,
  );

  return users;
};

export const getProfileQuery = async (id) => {
  const profile = await sendQuery(
    `query {
      users(filterUsersInput: {id: ${id}}) {
        data {
          id
          mobile
          nationalCode
          firstNameFa
          lastNameFa
          status {
            id
            title
            code
          }
          birthDate
          registerDate
          registerNumber
          merchantType
          telephoneNumber
          emailAddress
          createdAt
          files
          wallets {
            id
            name
            isMain
            walletType
          }
          tickets {
            id
            title
            createdAt
            updatedAt
            status{
              title
            }
          }
          terminals {
            id
            farsiName
            logo
            accessAddress
            status{
              title
            }
          }
          paymentForms {
            id
            title
          }
          settleable
          countTransactions
          totalTransactions
        }
      }
    }`,
  );

  return profile;
};

export const getTerminalsQuery = async () => {
  const data = await sendQuery(
    `query {
      terminals {
        data {	
          id
          farsiName
          merchantCode
          logo
          accessAddress
          returnToShopCheck
          autoSettlementAccount
          accounts {
            id
            bankName
            merchantIban
          }
          status {
            title
            code
            id
          }
          terminalType {
            id
            title
          }
          contracts {
            feePayer
            stepFee
          }
          wallet {
            id
            walletType
            name
          }
          terminalConfigs {
            id
            terminalNumber
            acceptorCode
            isActive
            pspConfig {
              id
              title
            }
          }
          sumDailyTransaction
          countDailyTransaction
        }
      }
    }`,
  );

  return data;
};

export const getFormsQuery = async (payload) => {
  payload = {
    ...payload,
    limit: 7,
  };
  const data = await sendQuery(
    `query filterForms($filterFormsInput: FilterPaymentFormsInput){
      paymentForms(filterPaymentFormsInput:$filterFormsInput){
        currentPage
        hasMorePages
        totalPages
        from
        to
        total
        data{
          id
          title
          mobile
          isActive
          expiresAt
          quantity
          createdAt
          url
          image
          amount
          singleUse
          colorPackage
          description
          branch{
            id
            title
          }
          status{
            id
            title
          }
          terminal{
            id
            farsiName
            logo
          }
        }
      }
      terminals{
        data{	
          id
          farsiName
        }
      }
    }`,
    'filterForms',
    {
      filterFormsInput: payload,
    },
  );

  return data;
};

export const getSingleFormQuery = async (payload) => {
  const data = await sendQuery(
    `query filterForms($filterFormsInput: FilterPaymentFormsInput){
      paymentForms(filterPaymentFormsInput:$filterFormsInput){
        currentPage
        hasMorePages
        totalPages
        from
        to
        total
        data{
          id
          title
          mobile
          isActive
          expiresAt
          quantity
          createdAt
          url
          image
          amount
          singleUse
          colorPackage
          redirectUrl
          description
          branch{
            id
            title
          }
          extraFields{
            id
            title
            isActive
            isRequired
            options
            type
          }
          terminal{
            id
            farsiName
            logo
          }
        }
      }
      terminals{
        data{	
          id
          farsiName
        }
      }
    }`,
    'filterForms',
    {
      filterFormsInput: payload,
    },
  );

  return data;
};

export const getTerminalNamesQuery = async () => {
  const data = await sendQuery(
    `query{
      terminals{
        data{
          id
          farsiName
          status{
            id
            title
          }
        }
      }
    }`,
  );
  return data;
};

export const getAccountsQuery = async () => {
  const data = await sendQuery(
    `query{
      accounts{
        data{
          user{
            id
            firstNameFa
            lastNameFa
          }
          id
          type
          title
          bankName
          cardNumber
          isMain
          merchantIban
          status{
            id
            title
          }
        }
      }
    }`,
  );

  return data;
};

export const getWalletsQuery = async () => {
  const data = await sendQuery(
    `query{
      wallets(filterWalletsInput:{limit:50}){
        data{
          id
          name
          walletType
          visibleAmounts{
            cash
            settleable
          }
        }
      }
      user{
        id
        simpleMessageWallet{
          balance
        }
      }
    }`,
  );

  return data;
};

// export const getTransactionsQuery = async (payload) => {
//   payload = {
//     ...payload,
//     transactionType: !payload?.transactionType
//       ? [0, 1, 2, 3, 4, 5, 6, 7]
//       : payload.transactionType,
//     limit: 7,
//   };
//   const data = await sendQuery(
//     `query
//     filterTransactions($filterTransactionsInput: FilterTransactionsInput){
//       transactions (filterTransactionsInput: $filterTransactionsInput){
//         currentPage
//         totalPages
//         perPage
//         total
//         sumIncome
//         countIncome
//         sumOutcome
//         countOutcome
//         data{
//           id
//           orderId
//           iban
//           irdId
//           amount
//           pan
//           refId
//           description
//           transactionDate
//           realtimeTotalAmount
//           transactionType
//           canBeCompleted
//           settlementStatus{
//             id
//             title
//             code
//           }
//           feeDetailTransaction{
//             customerValue
//           }
//           webserviceRequestStatus{
//             id
//             title
//           }
//           webserviceReversalStatus{
//             id
//             title
//           }
//           webserviceSettlementStatus{
//             id
//             title
//           }
//           webserviceVerificationStatus{
//             id
//             title

//           }
//           transactionStatus{
//             title
//             description
//           }

//         }
//       }

//       terminals{
//         data{
//           id
//           farsiName
//         }
//        }
//        wallets{
//         data{
//           id
//           name
//           }
//         }
//         paymentForms(filterPaymentFormsInput:{limit:${1000}}){
//           data{
//             id
//             title
//           }
//         }
//     }

//     `,
//     'filterTransactions',
//     {
//       filterTransactionsInput: payload,
//     }
//   );

//   return data;
// };

export const getAllTransactionsQuery = async (payload) => {
  payload = {
    ...payload,
    transactionType: !payload?.transactionType
      ? [0, 1, 2, 3, 4, 5, 6, 7, 8]
      : payload.transactionType,
    limit: 1000000000,
  };
  const data = await sendQuery(
    `query
    filterTransactions($filterTransactionsInput: FilterTransactionsInput){
      transactions (filterTransactionsInput: $filterTransactionsInput){
        data {
          id
          irdId
          refCode
          amount
          receivedAmount
          acceptorValue
          customerValue
          datetime
          realtimeTotalAmount
          mobile
          pan
          description
          transactionType
          account {
            merchantIban
          }
          indirectTransaction {
            orderId
          }
        }
      }
    }
    `,
    'filterTransactions',
    {
      filterTransactionsInput: payload,
    },
  );

  return data;
};

export const getTransactionsQuery = async (payload) => {
  payload = {
    ...payload,
    transactionType: !payload?.transactionType
      ? [0, 1, 2, 3, 4, 5, 6, 7, 8]
      : payload.transactionType,
    limit: 7,
  };
  const data = await sendQuery(
    `query
    filterTransactions($filterTransactionsInput: FilterTransactionsInput){
      transactions (filterTransactionsInput: $filterTransactionsInput){
        currentPage
        totalPages
        perPage
        total
        sumIncome
        countIncome
        sumOutcome
        countOutcome
        data {
          id
          irdId
          refCode
          amount
          receivedAmount
          acceptorValue
          customerValue
          datetime
          realtimeTotalAmount
          mobile
          pan
          transactionType
          currentStatus
          account {
            merchantIban
          }
          transactionStatus {
            title
            description
          }
          indirectTransaction {
            orderId
          }
        }
      }
      terminals {
        data {
          id
          farsiName
        }
      }
      wallets {
        data {
          id
          name
        }
      }
      paymentForms(filterPaymentFormsInput:{limit:${1000}}) {
        data {
          id
          title
        }
      }
    }
    `,
    'filterTransactions',
    {
      filterTransactionsInput: payload,
    },
  );

  return data;
};

// export const getExtraTransactionQuery = async (id) => {
//   const data = await sendQuery(
//     `query {
//       transactions(filterTransactionsInput: { id: ${id} }){
//         data{
//           id
//           refId
//           orderId
//           psp
//           amount
//           feeDetailTransaction{
//             customerValue
//           }
//           paymentFormTransaction{
//             id
//             authority
//             mobile
//             extraFieldValues
//             quantity
//           }
//           realtimeTotalAmount
//           irdId
//           iban
//           pan
//           description
//           wallet{
//             id
//             name
//           }
//           settlementStatus{
//             id
//           }
//           transactionDate
//           realtimeTotalAmount
//           transactionType

//         }
//       }
//     }`
//   );

//   return data;
// };

export const getExtraTransactionQuery = async (id) => {
  const data = await sendQuery(
    `query {
      transactions(filterTransactionsInput: {id: ${id}}) {
        data { 
          id
          irdId
          amount
          receivedAmount
          customerValue
          acceptorValue
          shaparakValue
          vat
          refCode
          pspId
          transactionDatetime
          branch {
            id
            title
          }
          paymentFormTransaction {
            id
            pspId
            authority
            mobile
            extraFieldValues
            quantity
            saleOrderId
          }
          indirectTransaction {
            orderId
            pspId
            mobile
          }
          realtimeTotalAmount
          account {
            merchantIban
          }
          mobile
          pan
          description
          wallet {
            id
            name
          }
          settlementStatus {
            id
          }
          datetime
          transactionType
        }
      }    
    }`,
  );
  return data;
};

export const getTicketsQuery = async () => {
  const data = await sendQuery(
    `query {
      tickets{
        data{ 
          id
          title
          status{
            id
            title
          }
          user{
            id
            firstNameFa
            lastNameFa
          }
          companySection{
            title
            id
          }
          createdAt
          updatedAt
        }
      } 
      companySections{
        id
        title
      }   
    }`,
  );

  return data;
};

export const getTicketProfileQuery = async (id) => {
  const data = await sendQuery(
    `query {
      tickets(filterTicketsInput:{id : ${id} }){
        data{ 
          comments{
            id
            message
            createdAt
            updatedAt
            files
            user{
              id
            }
          }
          id
          title
          status{
            id
            title
          }
          user{
            id
            firstNameFa
            lastNameFa
          }
          companySection{
            title
            id
          }
          createdAt
          updatedAt
        }
      } 
    }`,
  );

  return data;
};

export const getNotficationsQuery = async () => {
  const data = await sendQuery(
    `query{
      user{
        configs
      }
    }`,
  );

  return data;
};

export const getUserQuery = async () => {
  const data = await sendQuery(
    `query{
      user{
        authentications{
          details
          type {
            id
          }
        }
        id
        files
        mobile
        firstNameFa
        lastNameFa 
        fatherNameFa
        birthDate 
        merchantType
        emailAddress
        activationCode
        nationalCode
        birthCrtfctNumber
        telephoneNumber
        registerNumber 
        registerDate
        nationalLegalCode
        comNameFa       
        configs
        gender
        affiliationCode
        instantSettlementAccess
        simpleMessageWallet{
          id
          balance
        }
        accounts{
          id
          title
          status{
            id
          }
          bankName
          merchantIban
        }
        status{
          id
          title
        }
      }
    }`,
  );

  return data;
};

export const getSettlementsQuery = async (payload) => {
  payload = {
    ...payload,
    limit: 7,
    transactionType: [2],
  };
  const data = await sendQuery(
    `query 
    filterTransactions($filterTransactionsInput: FilterTransactionsInput){
      transactions (filterTransactionsInput: $filterTransactionsInput){
        currentPage
        totalPages
        perPage
        total
        data{
          id
          irdId
          amount
          customerValue
          acceptorValue
          refCode
          realtimeTotalAmount
          datetime
          transactionType
          wallet{
            walletType
          }
          settlement{
            amPm
            cycle
            effectiveDate
            settlementDate
          }
          account{
            merchantIban
          }
          settlementStatus{
            id
            title
            code
          }
        }
      }
    
      wallets(filterWalletsInput:{limit:50}){
        data{
          id
          name
          walletType
          visibleAmounts {
            id
            pspName
            settleable
          }
        }
      }

      accounts{
        data{
          id
          type
          merchantIban
          status{
            id
          }
        } 
      }

      settlementStatuses{
        id
        title
        code
      } 
    }
    `,
    'filterTransactions',
    {
      filterTransactionsInput: payload,
    },
  );

  return data;
};

// export const getSettlementsQuery = async (payload) => {
//   payload = {
//     ...payload,
//     limit: 7,
//     transactionType: [2],
//   };
//   const data = await sendQuery(
//     `query
//     filterTransactions($filterTransactionsInput: FilterTransactionsInput){
//       transactions (filterTransactionsInput: $filterTransactionsInput){
//         currentPage
//         totalPages
//         perPage
//         total
//         data{
//           id
//           irdId
//           amount
//           iban
//           refId
//           transactionDate
//           realtimeTotalAmount
//           transactionType
//           wallet{
//             walletType
//           }
//           settlement{
//             amPm
//             effectiveDate
//             settlementDate
//           }
//           settlementStatus{
//             id
//             title
//             code
//           }
//           feeDetailTransaction{
//             customerValue
//           }
//           webserviceRequestStatus{
//             id
//             title
//           }
//           webserviceReversalStatus{
//             id
//             title
//           }
//           webserviceSettlementStatus{
//             id
//             title
//           }
//           webserviceVerificationStatus{
//             id
//             title

//           }

//         }
//       }

//        wallets(filterWalletsInput:{limit:50}){
//         data{
//           id
//           name
//           walletType
//           visibleAmounts {
//           id
//           pspName
//           settleable
//              }
//           }
//         }
//         accounts{
//          data{

//         id
//         type
//         merchantIban
//         status{
//           id
//         }
//            }
//         }
//         settlementStatuses{
//           id
//           title
//           code
//         }
//     }

//     `,
//     'filterTransactions',
//     {
//       filterTransactionsInput: payload,
//     }
//   );

//   return data;
// };

export const getDashboardQuery = async () => {
  const data = await sendQuery(
    `query {
      wallets{
        total
        data{
          id
          name
          walletType
          visibleAmounts{
            id
            cash
            settleable
          }
        }
      } 
      terminals{
        total
        data{
          id
          farsiName
          accessAddress
          terminalType{
            title
          }
          status{
            id
            title
          }
        }
      }
      statistics{
        numberOfSuccessfulTransactions
        numberOfUnsuccessfulTransactions
        numberOfDailyTransactions
        totalOfDailyTransactions
        totalDeposits
        totalWithdrawals
        totalBalance
      }
    }`,
  );

  return data;
};

export const getLastDepositsQuery = async (payload) => {
  payload = {
    limit: 5,
    transactionType: [0, 1, 4, 5, 6, 7],
  };
  const data = await sendQuery(
    `query
    filterTransactions($filterTransactionsInput: FilterTransactionsInput){
      transactions (filterTransactionsInput: $filterTransactionsInput){
        data{
          id
          amount
          customerValue
          acceptorValue
          pan
          datetime
        }
      }
    }
    `,
    'filterTransactions',
    {
      filterTransactionsInput: payload,
    },
  );

  return data;
};

export const getLastSettlementsQuery = async (payload) => {
  payload = {
    limit: 5,
    transactionType: [2],
  };
  const data = await sendQuery(
    `query
    filterTransactions($filterTransactionsInput: FilterTransactionsInput){
      transactions (filterTransactionsInput: $filterTransactionsInput){
        data{
          id
          amount
          account{
            merchantIban
          }
          datetime
        }
      }
    }
    `,
    'filterTransactions',
    {
      filterTransactionsInput: payload,
    },
  );

  return data;
};

export const getTransactionsChartQuery = async (payload) => {
  const data = await sendQuery(
    `query
    filterTransactions(
      $filterTransactionsChartInput: FilterTransactionsChartInput!,
      $filterCheckoutsChartInput: FilterTransactionsChartInput!
    ) {
      transactions: transactionsChart(filterTransactionsChartInput: $filterTransactionsChartInput) {
        date
        amount
        month
        count
      },
      checkouts: transactionsChart(filterTransactionsChartInput: $filterCheckoutsChartInput) {
        date
        amount
        month
        count
      }
    }
    `,
    'filterTransactions',
    {
      filterTransactionsChartInput: (({
        period,
        terminalId,
        transactionType,
      }) => ({
        period,
        terminalId,
        type: transactionType,
      }))(payload),
      filterCheckoutsChartInput: (({ period, terminalId, checkoutType }) => ({
        period,
        terminalId,
        type: checkoutType,
      }))(payload),
    },
  );

  return data;
};

export const getPublicNotificationsQuery = async (payload) => {
  const data = await sendQuery(
    `query
    filterNotifications($filterNotificationsInput: FilterNotificationsInput){
      notifications (filterNotificationsInput: $filterNotificationsInput){
        data{
          id
          title
          body
          sentToAll
          datetime
          notificationToUsers{
            isRead
          }
        }
      }
    }
    `,
    'filterNotifications',
    {
      filterNotificationsInput: payload,
    },
  );

  return data;
};

export const getEffectiveDatesQuery = async ({ walletId }) => {
  const data = await sendQuery(
    `query effectiveDates($walletId: Int!){
      effectiveDates(walletId:$walletId){
        settleableAmount,
        date
        pspName
        walletAmountId
      }
      otherFeeTypes{
        id
        usable
        title
        details
      }
    }`,
    'effectiveDates',
    {
      walletId,
    },
  );

  return data;
};

export const getAffiliatesQuery = async () => {
  const data = await sendQuery(
    `query {

      user {
        id
        firstNameFa
        affiliationCode
        affiliationBalance
      }
    
      affiliates {
        numberOfTransactions
        sumOfTransactions
        numberOfAffiliations
        sumOfSettlements
        affiliatedUsers {
          affiliate {
            firstNameFa
            lastNameFa
            mobile
            createdAt
          }
          numberOfTransactions
          sumOfTransactions
          profitOfRecruiter
        }
      }
      
      transactionsChart(filterTransactionsChartInput:{period:"week" ,type:"affiliation"}) {
        date
        amount
        count
      }

    }`,
  );

  return data;
};

export const getCommissionBackQuery = async (payload) => {
  payload = {
    ...payload,
    limit: 7,
  };
  const data = await sendQuery(
    `query filterCommissionBackTransactions($filterCommissionBackTransactionsInput: FilterCommissionBackTransactionsInput) {
      commissionBackTransactions(filterCommissionBackTransactionsInput: $filterCommissionBackTransactionsInput) {
        currentPage
        totalPages
        perPage
        total
        data {
          type
          amount
          commissionBackPercent
          user {
            id
            activationCode
            mobile
          }
          transaction{
            amount
            customerValue
            acceptorValue
            id
            irdId
            transactionType
            terminal{
              id
              farsiName
            }
            refCode
          }
          datetime
        }
      }
      transactionsChart(filterTransactionsChartInput:{period:"week" ,type:"commissionBack" }){
        date
        amount
        count
      }
      user{
        id
        commissionBack
        commissionBackBalance
      }
    }`,
    'filterCommissionBackTransactions',
    {
      filterCommissionBackTransactionsInput: payload,
    },
  );

  return data;
};

export const getMessageWalletTransactionsQuery = async (payload) => {
  payload = {
    ...payload,
    limit: 7,
  };
  const data = await sendQuery(
    `query filterSimpleMessageWalletTransactions($filterSimpleMessageWalletTransactionsInput: FilterSimpleMessageWalletTransactionsInput) {
      simpleMessageWalletTransactions(filterSimpleMessageWalletTransactionsInput: $filterSimpleMessageWalletTransactionsInput) {
        currentPage
        totalPages
        perPage
        total
        data {
          amount
          simpleMessageWallet{
            id
            balance
          }
          status
          saleOrderId
          authority
          refCode
          refId
          pan
          type
          saleReferenceId
          datetime
          description
        }
      }
    }`,
    'filterSimpleMessageWalletTransactions',
    {
      filterSimpleMessageWalletTransactionsInput: payload,
    },
  );

  return data;
};

export const getTerminalContractsQuery = async () => {
  const data = await sendQuery(
    `query {
      terminals {
        data {
          id
          farsiName
          contracts {
            feePayer
            stepFee
            type
            dailyTransactionsSum
            dailyTransactionsCount
            dailyTransactionsSumCeil
            dailyTransactionsCountCeil
          }
        }
      }
    }`,
  );

  return data;
};

export const getPaymentFormsQuery = async () => {
  const data = await sendQuery(
    `query {
      paymentForms {
        data {
          id
          title
          contracts {
            feePayer
            stepFee
            dailyTransactionsSum
            dailyTransactionsCount
            dailyTransactionsSumCeil
            dailyTransactionsCountCeil
          }
        }
      }
    }`,
  );

  return data;
};

export const getUserSettlementContractQuery = async () => {
  const data = await sendQuery(
    `query {
      user {
        id
        instantSettlementAccess
        settlementContracts {
          id
          stepFee
          type
        }
      }
    }`,
  );

  return data;
};

export const getUserServicesQuery = async () => {
  const data = await sendQuery(
    `query {
      user{
        serverIp
        serverDomain
        permissionForApi
        apiToken
        inquiryServices{
          id
          title
          defaultService
        }
      }
      inquiryServices{
        id
        title
        titleFa
        defaultService
      }
    }`,
  );

  return data;
};

export const getBranchQuery = async () => {
  const res = await sendQuery(
    `query {
      branch{
        id
        title
        username
        branchUser{
          id    
          firstNameFa
          lastNameFa  
          configs
          files
          status{
            id
            title
          }
        }
         adminUser{
          id
          mobile
          comNameFa
          simpleMessageWallet{
            id
            balance
          }
        }
      }
    }`,
  );

  return res;
};

export const getBranchNamesQuery = async (payload) => {
  const data = await sendQuery(
    `query
    filterBranches($filterBranchesInput: FilterBranchesInput){
      branches (filterBranchesInput: $filterBranchesInput){
        data {
          id
          title
        }
      }
    }
    `,
    'filterBranches',
    {
      filterBranchesInput: payload,
    },
  );

  return data;
};

export const getBranchesQuery = async (payload) => {
  payload = { ...payload, limit: 7 };
  const data = await sendQuery(
    `query
    filterBranches($filterBranchesInput: FilterBranchesInput){
      branches (filterBranchesInput: $filterBranchesInput){
        totalPages
        currentPage
        data {
          id
          title
          username
          createdAt
          terminal {
            id
            farsiName
          }
          status{
            id
            title
          }
        }
      }
    }
    `,
    'filterBranches',
    {
      filterBranchesInput: payload,
    },
  );

  return data;
};
